import { productsMock } from './productsMock'

export const moreSellerItemsMock = {
  products: productsMock,
}
